export interface DownloadableBlob {
  blob: Blob;
  filename: string;
}

export function saveDownload(download: DownloadableBlob): void {
  const url = URL.createObjectURL(download.blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = download.filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
